/* ===== New-site runtime address map (added by convert2.py, not in the local mock) =====
   The mock reads pictures as "assets/<folder>/<file>" and links pages as "site/<page>.html".
   On Shopify every file is flat ("np-<folder>-<file>") and pages have their own routes, so every
   address the mock's code writes (innerHTML, src, href, XHR, location) goes through NPU() here.
   Data files (.json) are served from window.NP_JSON (np-data.js) without a request. */
(function () {
  var A = window.NPA, F = window.NPF || window.NPA, J = window.NP_JSON || {}, HAS = window.NP_HAS || {}, VER = window.NP_VER || {};
  var CODE = /\.(js|css)$/i;
  function flat(p) { return "np-" + p.replace(/\//g, "-"); }
  var PAGE = { how: "/pages/how-it-works", reviews: "/pages/reviews", studio: "/pages/about", contact: "/pages/contact",
    faq: "/pages/faq", shipping: "/pages/shipping-returns", track: "/pages/track", cart: "/cart", search: "/search",
    account: "/account", theme: "/pages/theme", landing: "/pages/for-who", ideas: "/pages/ideas", business: "/pages/business",
    "black-friday": "/pages/black-friday", "november-sale": "/pages/november-sale", keepsakes: "/pages/accessories", accessory: "/pages/accessory", grow: "/pages/grow",
    "ai-studio": "/pages/ai-studio", "ai-tool": "/pages/ai-studio?view=np-ai-tool", "your-mini": "/pages/ai-studio?view=np-your-mini", saved: "/pages/saved", gifts: "/pages/for-who?c=forwho", "card-options": "/" };
  var POL = { privacy: "/policies/privacy-policy", refund: "/policies/refund-policy", terms: "/policies/terms-of-service",
    shipping: "/policies/shipping-policy", "shipping-policy": "/policies/shipping-policy", contact: "/policies/contact-information",
    "contact-information": "/policies/contact-information", legal: "/policies/legal-notice", "legal-notice": "/policies/legal-notice",
    "privacy-choices": "/pages/data-sharing-opt-out" };
  function page(name, q, h) {
    if (name === "home" || name === "index" || name === "mobile") return "/" + q + h;
    if (name === "phone") {
      var sp = new URLSearchParams(q.replace(/&amp;/g, "&")), p = sp.get("p"), /* cards write their links HTML-escaped (&amp;): read the real query */ dh = sp.get("t") && sp.get("d") ? "d-" + sp.get("t") + "-" + sp.get("d") : "";
      /* SEO (page checker 30 Oct): a design with its own product (NP_DPROD: the active d-* handles, np-data.js) links to /products/d-<theme>-<id>,
         its own title and canonical. That page sets p, t and d itself (DESIGNJS), so only the rest of the query (tp, from...) travels.
         Custom-only ideas keep /products/custom-clayfie?...&d=. */
      if (dh && window.NP_DPROD && !window.NP_DPROD[dh] && window.cfIdIn) { var pi = window.cfIdIn(sp.get("t"), sp.get("d")), ph = "d-" + pi[0] + "-" + pi[1]; if (window.NP_DPROD[ph]) dh = ph; } /* public ids -> internal handle */
      if (dh && window.NP_DPROD && window.NP_DPROD[dh]) { sp.delete("p"); sp.delete("t"); sp.delete("d"); var rest = sp.toString(); return "/products/" + (typeof window.NP_DPROD[dh] === "string" ? window.NP_DPROD[dh] : dh) + (rest ? "?" + rest : "") + h; } /* a string = the store renamed that handle (Nature calls, 2 Nov) */
      /* public ids in the address (Nature calls, Sava 2 Nov: CF_ID_PUB in np-menu.js): naturecalls / nature-calls, never the internal caganer */
      if (window.cfIdOut && sp.get("t")) { var po = window.cfIdOut(sp.get("t"), sp.get("d")); if (po[0] !== sp.get("t") || (sp.get("d") && po[1] !== sp.get("d"))) { sp.set("t", po[0]); if (sp.get("d")) sp.set("d", po[1]); q = "?" + sp.toString(); } }
      return (p === "pet" ? "/products/pet-mini" : "/products/custom-clayfie") + q + h;
    }
    if (name === "policy") { var k = new URLSearchParams(q).get("p"); return (POL[k] || POL.privacy) + h; }
    /* SEO (30 Oct): a theme page that is also a collection (NP_COLL, np-data.js) lives at /collections/<id> */
    if (name === "theme") {
      var tq = new URLSearchParams(q.replace(/&amp;/g, "&")), tt = tq.get("t");
      if (tt && COLL.indexOf(tt) >= 0) { tq.delete("t"); var tr = tq.toString(); return "/collections/" + tt + (tr ? "?" + tr : "") + h; }
    }
    var r = PAGE[name];
    if (!r) return null;
    if (r.indexOf("?") > 0 && q) return r + "&" + q.slice(1) + h;
    return r + q + h;
  }
  var COLL = window.NP_COLL || [];
  /* old links to /pages/theme?t=<id> open the collection, which is now the theme page (SEO, 30 Oct) */
  if (location.pathname === "/pages/theme") {
    var oq = new URLSearchParams(location.search), ot = oq.get("t") || "christmas";
    if (COLL.indexOf(ot) >= 0) { oq.delete("t"); var orr = oq.toString(); location.replace("/collections/" + ot + (orr ? "?" + orr : "") + location.hash); }
  }
  var FLAT = {}; Object.keys(HAS).forEach(function (k) { FLAT[flat(k)] = k; });
  /* more NP_HAS entries from a page's own bundle (np-data-hiw.js on product pages, speed 1 Nov) */
  window.NPhas = function (o, c) { for (var k in o) { H0[k] = o[k]; FLAT[flat(k)] = k; } if (c) c.forEach(function (p) { CP.push(p); }); };
  window.NPjson = function (o) { for (var k in o) J0[k] = o[k]; };
  /* speed (1 Nov): the head loads only this page type's part of the list (np-data-<type>.js, split_data.py). NP_PART says where
     that part is complete (folders "c", name patterns "a") and names every data file ("jk"). A script asking for a name outside it
     gets the full list (np-data.js, window.NP_REST) first, so every answer is the same as before; the rest also loads once the page is idle. */
  var PART = window.NP_PART, RESTU = window.NP_REST, restDone = !PART || !RESTU, restP = null, H0 = HAS, J0 = J, JK = {};
  var CP = PART ? PART.c.slice() : [], CR = PART ? PART.a.map(function (r) { return new RegExp(r); }) : [];
  if (PART) PART.jk.forEach(function (k) { JK[k] = 1; });
  function known(k) { for (var i = 0; i < CP.length; i++) if (k.indexOf(CP[i]) === 0) return true; for (i = 0; i < CR.length; i++) if (CR[i].test(k)) return true; return false; }
  function restAdd(t) {
    try {
      var a = t.indexOf("window.NP_JSON="), b = t.indexOf(";window.NP_HAS="), c = t.indexOf(";window.NP_VER="), j = JSON.parse(t.slice(a + 15, b)), h = JSON.parse(t.slice(b + 15, c)), k;
      for (k in h) if (!(k in H0)) { H0[k] = h[k]; FLAT[flat(k)] = k; }
      for (k in j) if (!(k in J0)) J0[k] = j[k];
    } catch (e) {}
    restDone = true;
  }
  function restSync(why) {
    if (restDone) return; restDone = true; window.NP_RESTWHY = why;
    try { var x = new XMLHttpRequest(); (XO || XMLHttpRequest.prototype.open).call(x, "GET", RESTU, false); (XS || XMLHttpRequest.prototype.send).call(x); if (x.status === 200) restAdd(x.responseText); } catch (e) {}
  }
  function restAsync() {
    if (restDone && !restP) return Promise.resolve();
    if (!restP) restP = (fe || window.fetch).call(window, RESTU).then(function (r) { return r.text(); }).then(restAdd, function () { restDone = true; });
    return restP;
  }
  /* only file names count ("x.jpg"), not probes such as "then" or "undefined" */
  function askH(t, k) { if (!restDone && typeof k === "string" && !(k in t) && /\.[a-z0-9]+$/i.test(k) && !known(k)) restSync(k); }
  if (PART && typeof Proxy === "undefined") restSync("no Proxy");
  else if (PART) {
    HAS = window.NP_HAS = new Proxy(H0, { get: function (t, k) { askH(t, k); return t[k]; }, has: function (t, k) { askH(t, k); return k in t; } });
    J = window.NP_JSON = new Proxy(J0, { get: function (t, k) { if (!restDone && typeof k === "string" && !(k in t) && JK[k]) restSync(k); return t[k]; } });
    addEventListener("load", function () { setTimeout(function () { (window.requestIdleCallback || setTimeout)(restAsync); }, 3000); });
  }
  /* NP_HAS value: "<version stamp>" or "<version stamp>.<width in px>" for jpg/png/webp (np-data.js) */
  function stamp(h) { return typeof h === "string" ? h.split(".")[0] : h; }
  /* a width asked for in the address: "width=" (a resized copy) is kept, and the mock's hint "cfw=<px>" (Builder 2, 29 Oct:
     CSS backgrounds and new Image() preloads) becomes "width=", never above the picture's own width */
  function wq(q, name) {
    var w = q && (q.match(/[?&](?:cfw|width)=(\d+)/) || [])[1], pw = pxWidth(name);
    return w && pw && +w < pw ? "&width=" + w : "";
  }
  function pxWidth(name) { var h = FLAT[name] && HAS[FLAT[name]]; return typeof h === "string" && h.indexOf(".") > 0 ? +h.split(".")[1] : 0; }
  function NPU(u) {
    if (typeof u !== "string" || !u) return u;
    /* a picture already on its theme address but with another stamp (the mock re-stamps with Date.now() as a cache-buster):
       one stamp per picture (its NP_HAS version), so it is downloaded once and cached */
    var fm = u.match(/^((?:https?:)?\/\/[^\/]+\/cdn\/shop\/t\/\d+\/assets\/)(np-[^?#]+)(\?[^#]*)?(#.*)?$/);
    if (fm && !CODE.test(fm[2]) && FLAT[fm[2]]) { var hv = stamp(HAS[FLAT[fm[2]]]); return fm[1] + fm[2] + (hv && hv !== 1 ? "?v=" + hv : "?v=1") + wq(fm[3], fm[2]) + (fm[4] || ""); }
    /* scripts that find "the site root" from their own address land in the theme's file folder: read it as the root */
    var root = u.match(/^(?:https?:)?(?:\/\/[^\/]+)?\/cdn\/shop\/t\/\d+\/(?!assets\/np-)(.*)$/);
    if (root) u = root[1] || "home.html";
    var m = u.match(/^(?:\.{1,2}\/)*assets\/([^?#]+)([?#].*)?$/);
    if (m) {
      var p = norm(decodeURIComponent(m[1])), v = CODE.test(p) ? VER[p] : stamp(HAS[p]);
      return (CODE.test(p) ? A : F) + flat(p) + (v && v !== 1 ? "?v=" + v : (CODE.test(p) ? "" : "?v=1")) + (CODE.test(p) ? "" : wq(m[2], flat(p)));
    }
    if (/^(?:[a-z]+:|\/\/|\/|#|\?)/i.test(u)) return u;
    m = u.match(/^(?:\.{1,2}\/)*(?:site\/)?([a-z0-9-]+)\.html(\?[^#]*)?(#.*)?$/i);
    if (m) { var r = page(m[1].toLowerCase(), m[2] || "", m[3] || ""); if (r) return r; }
    return u;
  }
  /* "bg/s2-themes/../../themes/x.jpg" -> "themes/x.jpg" before flattening */
  function norm(p) { var out = []; p.split("/").forEach(function (x) { if (x === "..") out.pop(); else if (x !== "." && x !== "") out.push(x); }); return out.join("/"); }
  /* the mock lists a folder ("assets/hero/", or "assets/" itself) to see which pictures exist: answer from the picture list, like a file server */
  function listing(dir) {
    if (!restDone && !known(dir + "x")) restSync(dir);
    var names = Object.keys(HAS).filter(function (k) { return k.indexOf(dir) === 0 && k.slice(dir.length).indexOf("/") < 0; }).map(function (k) { return k.slice(dir.length); });
    return "<html><body>" + names.map(function (n) { return '<a href="' + n + '">' + n + "</a>"; }).join("\n") + "</body></html>";
  }
  window.NPU = NPU;
  /* the mock's width hint cfW(url, px) (card.js) is used for CSS backgrounds set through el.style.background, which these hooks can't
     catch before the browser asks for them: cfW itself returns the final theme address (with &width=), so nothing raw is ever requested */
  var cfw0 = null;
  Object.defineProperty(window, "cfW", { configurable: true,
    get: function () { return function (u, px) { var r = cfw0 ? cfw0(u, px) : (!u || !px ? u : u + (/\?/.test(u) ? "&" : "?") + "cfw=" + px); return NPU(r); }; },
    set: function (f) { cfw0 = f; } });
  /* "assets/x" path relative to assets/, for the JSON bundle and the picture list */
  function rel(u) {
    if (typeof u !== "string") return null;
    /* a data file asked for by its theme address (scripts that build it from their own src, e.g. tags.js):
       ".../assets/np-design-tags.json" is the bundle's "design-tags.json" */
    var f = u.match(/\/cdn\/shop\/t\/\d+\/assets\/np-([^?#\/]+\.json)/i);
    if (f) { if (J[f[1]] !== undefined) return f[1]; for (var k in J) if (flat(k) === "np-" + f[1]) return k; }
    u = u.replace(/^(?:https?:)?(?:\/\/[^\/]+)?\/cdn\/shop\/t\/\d+\/(?=assets\/(?!np-))/, "");
    var m = u.match(/^(?:\.{1,2}\/)*assets\/([^?#]*)/); return m ? (/\/$/.test(m[1]) || !m[1] ? m[1] : norm(decodeURIComponent(m[1]))) : null;
  }

  var ATTR = /(\s(?:src|href|poster|data-[a-z0-9-]+|action)\s*=\s*)(["'])([^"']*)\2/gi;
  var SRCSET = /(\ssrcset\s*=\s*)(["'])([^"']*)\2/gi;
  var URLF = /url\((["']?)([^)"']+)\1\)/gi;
  /* phone-sized pictures (Sava: phone Lighthouse 80+): Shopify's CDN resizes theme pictures with &width= (never larger than the
     original, WebP where the browser takes it). Every <img> of a theme jpg/png/webp gets a srcset of these widths; its "sizes"
     comes from the page (the builder's hint per card), else full width. Ours are marked data-npss so a later src change redoes them. */
  var WIDTHS = [360, 540, 720, 960, 1200, 1600, 2000];
  var RESIZABLE = /\/assets\/np-[^?#"' ]+\.(?:jpe?g|png|webp)(?:\?[^#"' ]*)?$/i;
  /* only widths smaller than the picture itself, plus the original at its real width: the CDN never enlarges, so every
     "w" in the list is the true width and the browser lays the picture out at its right size */
  /* hasSizes: the page gave this picture its "sizes". Without one the browser takes the full screen width as the picture's own
     size, so only big photos (1000 px and up, always sized by the layout) get a srcset then; small pictures stay as they were */
  function srcsetFor(u, hasSizes) {
    if (typeof u !== "string" || !RESIZABLE.test(u)) return "";
    var nm = (u.match(/\/assets\/(np-[^?#]+)/) || [])[1], pw = nm ? pxWidth(nm) : 0;
    if (!pw || (!hasSizes && pw < 1000)) return "";
    u = u.replace(/&width=\d+/, "");
    var sep = u.indexOf("?") >= 0 ? "&" : "?";
    return WIDTHS.filter(function (w) { return w < pw; }).map(function (w) { return u + sep + "width=" + w + " " + w + "w"; }).concat([u + " " + pw + "w"]).join(", ");
  }
  window.NPsrcset = srcsetFor;
  var IMGTAG = /<img\b[^>]*>/gi, SRCTAG = /<source\b[^>]*>/gi;
  /* <picture><source media=... srcset="one file"> (phone banners): the same width list */
  function srcTag(t) {
    var m = t.match(/\ssrcset\s*=\s*(["'])([^"',\s]+)\1/i); if (!m) return t;
    var ss = srcsetFor(m[2], /\ssizes\s*=/i.test(t)); if (!ss) return t;
    t = t.replace(m[0], ' srcset="' + ss + '"');
    return /\ssizes\s*=/i.test(t) ? t : t.replace(/^<source\b/i, '<source sizes="100vw"');
  }
  function imgTag(t) {
    if (/\ssrcset\s*=/i.test(t)) return t;
    var m = t.match(/\ssrc\s*=\s*(["'])([^"']*)\1/i); if (!m) return t;
    var ss = srcsetFor(m[2], /\ssizes\s*=/i.test(t)); if (!ss) return t;
    return t.replace(/^<img\b/i, '<img data-npss="1" srcset="' + ss + '"' + (/\ssizes\s*=/i.test(t) ? ' data-npsz="1"' : ' sizes="100vw"'));
  }
  function html(s) {
    if (typeof s !== "string" || (s.indexOf("assets/") < 0 && s.indexOf(".html") < 0)) return s;
    return s.replace(ATTR, function (all, a, q, v) { return a + q + NPU(v) + q; })
      .replace(SRCSET, function (all, a, q, v) { return a + q + v.split(",").map(function (x) { x = x.trim().split(/\s+/); x[0] = NPU(x[0]); return x.join(" "); }).join(", ") + q; })
      .replace(URLF, function (all, q, v) { return "url(" + q + NPU(v) + q + ")"; })
      .replace(IMGTAG, imgTag).replace(SRCTAG, srcTag);
  }
  /* CSS background photos: never wider than the screen needs (next width step above screen width x pixel ratio) */
  function bgSized(u) {
    var nm = typeof u === "string" && RESIZABLE.test(u) && (u.match(/\/assets\/(np-[^?#]+)/) || [])[1];
    var pw = nm ? pxWidth(nm) : 0, need = Math.ceil((window.innerWidth || 1440) * (window.devicePixelRatio || 1));
    var w = WIDTHS.filter(function (x) { return x >= need; })[0];
    return w && pw > w && !/[?&]width=/.test(u) ? u + (u.indexOf("?") >= 0 ? "&" : "?") + "width=" + w : u;
  }
  function css(s) { return typeof s === "string" && s.indexOf("assets/") >= 0 ? s.replace(URLF, function (all, q, v) { return "url(" + q + bgSized(NPU(v)) + q + ")"; }) : s; }
  window.NPhtml = html;

  function hookProp(proto, prop, fn) {
    var d = proto && Object.getOwnPropertyDescriptor(proto, prop);
    if (!d || !d.set) return;
    Object.defineProperty(proto, prop, { configurable: true, enumerable: d.enumerable, get: d.get,
      set: function (v) { var r = fn.call(this, v); if (prop === "src" && this instanceof HTMLImageElement && this.getAttribute("src") === r) return; d.set.call(this, r); } });
  }
  hookProp(Element.prototype, "innerHTML", html);
  hookProp(Element.prototype, "outerHTML", html);
  var dw = document.write, dwl = document.writeln;
  document.write = function () { return dw.apply(document, Array.prototype.map.call(arguments, html)); };
  document.writeln = function () { return dwl.apply(document, Array.prototype.map.call(arguments, html)); };
  var iah = Element.prototype.insertAdjacentHTML;
  Element.prototype.insertAdjacentHTML = function (w, s) { return iah.call(this, w, html(s)); };
  var sa = Element.prototype.setAttribute;
  /* an <img> whose src/srcset/sizes is set again to the value it already has is left alone: Chrome would count it as a new image
     and restart LCP (the product page's adopted first-HTML picture, page checker 30 Oct) */
  var IMGATTR = { src: 1, srcset: 1, sizes: 1 };
  Element.prototype.setAttribute = function (n, v) {
    var k = String(n).toLowerCase();
    if (IMGATTR[k] && window.HTMLImageElement && this instanceof HTMLImageElement) {
      var mv = k === "src" ? NPU(String(v)) : k === "srcset" ? srcset(String(v)) : String(v);
      if (this.getAttribute(k) === mv) return;
    }
    if (k === "src" || k === "href" || k === "poster" || k === "action" || k.indexOf("data-") === 0) { v = NPU(String(v)); if (k === "src" && window.HTMLImageElement && this instanceof HTMLImageElement && typeof imgSet === "function") imgSet(this, v); }
    else if (k === "srcset") v = String(v).split(",").map(function (x) { x = x.trim().split(/\s+/); x[0] = NPU(x[0]); return x.join(" "); }).join(", ");
    else if (k === "style") v = css(String(v));
    return sa.call(this, n, v);
  };
  /* before an <img> gets a new src: our srcset follows it (else the old srcset would keep showing the old picture) */
  function imgSet(el, u) {
    if (!(el instanceof HTMLImageElement) || (el.hasAttribute("srcset") && !el.hasAttribute("data-npss"))) return;
    if (!el.hasAttribute("data-npss") && el.hasAttribute("sizes")) sa.call(el, "data-npsz", "1");  /* the page's own sizes: never overwritten */
    var own = el.hasAttribute("data-npsz"), ss = srcsetFor(u, own);
    if (ss) { if (!el.hasAttribute("data-npss")) sa.call(el, "data-npss", "1"); if (!own && el.getAttribute("sizes") !== "100vw") sa.call(el, "sizes", "100vw"); if (el.getAttribute("srcset") !== ss) sa.call(el, "srcset", ss); }
    else if (el.hasAttribute("data-npss")) { el.removeAttribute("srcset"); el.removeAttribute("data-npss"); if (!own) el.removeAttribute("sizes"); }
  }

  [window.HTMLSourceElement, window.HTMLMediaElement, window.HTMLScriptElement, window.HTMLIFrameElement].forEach(function (C) { if (C) hookProp(C.prototype, "src", NPU); });
  /* an undefined src (a lazy loader reading a data-src that an earlier wake already used) keeps the picture it has */
  if (window.HTMLImageElement) hookProp(HTMLImageElement.prototype, "src", function (v) { if (v == null || v === "undefined") return this.getAttribute("src") || ""; var u = NPU(v); if (this.getAttribute("src") !== u) imgSet(this, u); return u; });
  var srcset = function (v) { return String(v).split(",").map(function (x) { x = x.trim().split(/\s+/); x[0] = NPU(x[0]); return x.join(" "); }).join(", "); };
  if (window.HTMLImageElement) hookProp(HTMLImageElement.prototype, "srcset", srcset);
  /* speed (1 Nov): a <source> given one big picture by a script (the home slides' phone pictures, source.srcset = "...-sq.jpg") gets the
     same width list as srcTag() above, so a phone asks for a 720/960px copy instead of the 1200px original */
  if (window.HTMLSourceElement) hookProp(HTMLSourceElement.prototype, "srcset", function (v) {
    var s = srcset(v).trim(); if (/[\s,]/.test(s)) return s;
    var ss = srcsetFor(s, this.hasAttribute("sizes")); if (!ss) return s;
    if (!this.hasAttribute("sizes")) sa.call(this, "sizes", "100vw");
    return ss; });
  if (window.HTMLMediaElement) hookProp(HTMLMediaElement.prototype, "poster", NPU);
  if (window.HTMLVideoElement) hookProp(HTMLVideoElement.prototype, "poster", NPU);
  [window.HTMLAnchorElement, window.HTMLAreaElement].forEach(function (C) { if (C) hookProp(C.prototype, "href", NPU); });
  /* a picture preload asks for exactly what its <img> will use (same srcset, the page's imagesizes), so it isn't downloaded twice */
  if (window.HTMLLinkElement) hookProp(HTMLLinkElement.prototype, "href", function (v) {
    var u = NPU(v);
    if (this.as === "image" && !this.hasAttribute("imagesrcset")) { var ss = srcsetFor(u, this.hasAttribute("imagesizes")); if (ss) { sa.call(this, "imagesrcset", ss); if (!this.hasAttribute("imagesizes")) sa.call(this, "imagesizes", "100vw"); } }
    return u;
  });
  if (window.HTMLFormElement) hookProp(HTMLFormElement.prototype, "action", NPU);
  var CSD = window.CSSStyleDeclaration && CSSStyleDeclaration.prototype;
  if (CSD) {
    ["backgroundImage", "background", "cssText", "maskImage", "webkitMaskImage"].forEach(function (p) { hookProp(CSD, p, css); });
    var sp = CSD.setProperty;
    CSD.setProperty = function (n, v, pr) { return sp.call(this, n, css(v), pr); };
  }

  /* inline styles set from code (el.style.background = "url(assets/...)"): current Chrome keeps background and
     backgroundImage off CSSStyleDeclaration.prototype, so the hooks above miss them. Rewrite the style attribute instead. */
  var fixStyle = function (el) {
    var v = el.getAttribute && el.getAttribute("style");
    if (!v || v.indexOf("assets/") < 0) return;
    var w = css(v); if (w !== v) sa.call(el, "style", w);
  };
  new MutationObserver(function (list) {
    list.forEach(function (r) {
      if (r.type === "attributes") fixStyle(r.target);
      else Array.prototype.forEach.call(r.addedNodes, function (n) { if (n.nodeType === 1) { fixStyle(n); if (n.querySelectorAll) Array.prototype.forEach.call(n.querySelectorAll("[style]"), fixStyle); } });
    });
  }).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ["style"] });

  /* XHR: data files come from the bundle; "does this picture exist" HEAD checks answer from the picture list */
  var XO = XMLHttpRequest.prototype.open, XS = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) {
    var r = rel(u); this._np = null;
    if (r !== null && (r === "" || /\/$/.test(r)) && String(m).toUpperCase() === "GET") this._np = { text: listing(r) };
    else if (r && /\.json$/i.test(r)) this._np = { body: J[r] };
    else if (r && String(m).toUpperCase() === "HEAD") this._np = { head: !!HAS[r] };
    if (this._np) { this._np.async = arguments[2] !== false; return; }
    var a = Array.prototype.slice.call(arguments); a[1] = NPU(u);
    return XO.apply(this, a);
  };
  XMLHttpRequest.prototype.send = function () {
    var n = this._np;
    if (!n) return XS.apply(this, arguments);
    var ok = n.text !== undefined ? true : n.head !== undefined ? n.head : n.body !== undefined;
    var txt = n.text !== undefined ? n.text : n.body !== undefined ? JSON.stringify(n.body) : "";
    Object.defineProperty(this, "readyState", { value: 4, configurable: true });
    Object.defineProperty(this, "status", { value: ok ? 200 : 404, configurable: true });
    Object.defineProperty(this, "responseText", { value: txt, configurable: true });
    Object.defineProperty(this, "response", { value: txt, configurable: true });
    var x = this, fire = function () { if (x.onreadystatechange) x.onreadystatechange(); if (ok && x.onload) x.onload(); if (!ok && x.onerror) x.onerror(); };
    if (n.async) setTimeout(fire, 0);
  };
  if (window.fetch) {
    var fe = window.fetch;
    window.fetch = function (u, o) {
      var r = rel(typeof u === "string" ? u : "");
      if (r !== null && (r === "" || /\/$/.test(r))) return Promise.resolve(new Response(listing(r), { status: 200, headers: { "Content-Type": "text/html" } }));
      if (r && /\.json$/i.test(r)) {
        /* a data file this page's part does not have: wait for the full list without holding up the page */
        var jr = function () { var v = J0[r]; return new Response(v !== undefined ? JSON.stringify(v) : "", { status: v !== undefined ? 200 : 404, headers: { "Content-Type": "application/json" } }); };
        return !(r in J0) && JK[r] && !restDone ? restAsync().then(jr) : Promise.resolve(jr());
      }
      return fe.call(this, typeof u === "string" ? NPU(u) : u, o);
    };
  }
  /* location writes in the mock go through NPloc (convert2.py rewrites location.href= / .replace( / .assign() */
  window.NPloc = {
    get href() { return location.href; }, set href(v) { location.href = NPU(v); },
    replace: function (v) { location.replace(NPU(v)); }, assign: function (v) { location.assign(NPU(v)); },
    get search() { return location.search; }, get pathname() { return location.pathname; }, get hash() { return location.hash; },
    set hash(v) { location.hash = v; }, reload: function () { location.reload(); }
  };
  var wo = window.open;
  window.open = function (u) { var a = Array.prototype.slice.call(arguments); a[0] = NPU(u); return wo.apply(window, a); };
  /* ready-made designs are their own Shopify products (handle d-<theme>-<design>) once published: a design link opens
     that product when it exists, else the Custom page with the design shown (same order lines either way) */
  var dcache = {};
  function designHref(a) {
    var u; try { u = new URL(a.href, location.href); } catch (e) { return null; }
    if (u.origin !== location.origin || !/^\/products\/(custom-clayfie|pet-mini)$/.test(u.pathname)) return null;
    var t = u.searchParams.get("t"), d = u.searchParams.get("d");
    if (!t || !d) return null;
    return { h: "d-" + t + "-" + d, q: u.search, hash: u.hash };
  }
  document.addEventListener("click", function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var a = e.target.closest && e.target.closest("a[href]"); if (!a) return;
    var d = designHref(a); if (!d) return;
    e.preventDefault();
    var go = function (ok) { location.href = ok ? "/products/" + d.h + d.q + d.hash : a.href; };
    if (d.h in dcache) return go(dcache[d.h]);
    fetch("/products/" + d.h + ".js", { method: "GET", headers: { Accept: "application/json" } })
      .then(function (r) { dcache[d.h] = r.ok; go(r.ok); }).catch(function () { go(false); });
  }, true);
  /* the mock's own "?v=" picture refresh is not needed: Shopify versions its files */
  /* accessory products (29 Oct): one per accessory, handle accessory-<key>, variants named as on the mock ("One piece",
     "Plain"...). The storefront only sees them once they are Active on the Online Store, so every accessory
     button asks first and stays "Coming soon" when the product is not there. npAcc(key) -> product .js (prices in cents) or null */
  /* the gift card (1 Nov) is its own product "gift-card", variants "$119" ... "$429" as on the mock */
  var acache = {}, AHANDLE = { gift: "gift-card" };
  window.npAcc = function (key) {
    if (!acache[key]) acache[key] = fetch("/products/" + (AHANDLE[key] || "accessory-" + key) + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    return acache[key];
  };
  /* accessory page "Add photo now" (30 Oct: it did nothing on Shopify): Add to cart first sends the photo to Shopify the way the mini page
     does (a cart line with the file as a property, so Shopify stores it and answers its address), keeps that address on the cfCart line
     (line.photoUrl, sent with the order at checkout) and takes the temporary line out again. Any failure keeps the line as "photo later". */
  var PHOTOPROP = "Photo — Your photo";
  function shrinkPhoto(f) {
    return new Promise(function (res) {
      if (!f || !/^image\/(jpe?g|png|webp)$/i.test(f.type || "") || f.size < 1200 * 1024) return res(f);
      var u = URL.createObjectURL(f), im = new Image();
      im.onload = function () {
        var s = Math.min(1, 2200 / Math.max(im.width, im.height)), c = document.createElement("canvas");
        c.width = Math.max(1, Math.round(im.width * s)); c.height = Math.max(1, Math.round(im.height * s));
        var x = c.getContext("2d"); if (!x || !c.toBlob) { URL.revokeObjectURL(u); return res(f); }
        x.fillStyle = "#fff"; x.fillRect(0, 0, c.width, c.height); x.drawImage(im, 0, 0, c.width, c.height);
        c.toBlob(function (b) { URL.revokeObjectURL(u); res(b && b.size < f.size ? new File([b], (f.name || "photo").replace(/\.\w+$/, "") + ".jpg", { type: "image/jpeg" }) : f); }, "image/jpeg", 0.85);
      };
      im.onerror = function () { URL.revokeObjectURL(u); res(f); };
      im.src = u;
    });
  }
  window.cfAccUpload = function (key, variant, file, line) {
    var later = function () { line.photo = "later"; return line; };
    if (!file) return Promise.resolve(later());
    return window.npAcc(key).then(function (p) {
      var v = window.npAccVar(p, variant || ""); if (!v) return later();
      return shrinkPhoto(file).then(function (f) {
        var fd = new FormData(); fd.append("id", v.id); fd.append("quantity", 1); fd.append("properties[" + PHOTOPROP + "]", f, f.name || "photo.jpg");
        return fetch("/cart/add.js", { method: "POST", headers: { Accept: "application/json", "X-NP": "1" }, body: fd }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || "Cart error"); return j; }); });
      }).then(function (item) {
        var u = item && item.properties && item.properties[PHOTOPROP];
        if (!u || !/\//.test(u)) return later();
        line.photoUrl = u;
        return fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id: item.key, quantity: 0 }) }).then(function () { return line; }, function () { return line; });
      });
    }).catch(function (e) { console.warn("Clayfie photo:", e); return later(); });
  };
  /* growing-up mini (1 Nov, product growing-up-mini, one variant): the grow page sends its photos the same way before it goes to the
     cart, as "Photo — Your child 1", "Photo — Your child 2" (the Mini-me order's "Photo — <name> <n>" form), and keeps their addresses
     on the cfCart line (line.photoUrls). Any failure keeps the line as "photo later". */
  window.npGrow = function () { return acache._grow || (acache._grow = fetch("/products/growing-up-mini.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; })); };
  window.cfGrowUpload = function (files, line) {
    var later = function () { line.photo = "later"; delete line.photoUrls; return line; };
    return window.npGrow().then(function (p) {
      var v = p && p.variants[0]; if (!v) return later();
      return Promise.all(files.map(shrinkPhoto)).then(function (fs) {
        var fd = new FormData(); fd.append("id", v.id); fd.append("quantity", 1);
        fs.forEach(function (f, i) { fd.append("properties[Photo — Your child " + (i + 1) + "]", f, f.name || "photo.jpg"); });
        return fetch("/cart/add.js", { method: "POST", headers: { Accept: "application/json", "X-NP": "1" }, body: fd }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || "Cart error"); return j; }); });
      }).then(function (item) {
        var pr = (item && item.properties) || {}, us = files.map(function (_, i) { return pr["Photo — Your child " + (i + 1)]; }).filter(function (u) { return u && /\//.test(u); });
        if (!us.length) return later();
        line.photoUrls = us;
        return fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id: item.key, quantity: 0 }) }).then(function () { return line; }, function () { return line; });
      });
    }).catch(function (e) { console.warn("Clayfie photo:", e); return later(); });
  };
  window.npAccVar = function (p, name) {
    if (!p) return null;
    /* a one-variant accessory answers to any name (old cart lines still say "With a mini") */
    return p.variants.find(function (v) { return v.title === name; }) || (!name || p.variants.length === 1 ? p.variants[0] : null) || null;
  };
})();
